
import AppData from '../../../../Model/AppData';
import MenuItemImage from '../../../../Model/MenuItemImage';
const instances = {}
export default class MenuItemImageRepository {
    /**
     * @param {*} app 
     * @return {MenuItemImageRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = AppData.data
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new MenuItemImageRepository(app)
        }
        return instances[app]
    }
    constructor(app) {
        this.app = app
        // Store which menu item's images had been loaded
        this.loadedMenuItem = []
        this.menuItemImages = []
        this.callbackMap = {}
    }

    filterMenuItemImages = (menuItem) => {
        return (this.menuItemImages || []).filter(menuItemImage => {
            return menuItemImage.menu_item_id == menuItem.id
        });
    }

    removeCallback = (callbackKey) => {
        Object.keys(this.callbackMap).forEach(menuItemId => {
            if (this.callbackMap[menuItemId] && this.callbackMap[menuItemId][callbackKey]) {
                delete this.callbackMap[menuItemId][callbackKey]
            }    
        })
    }

    /**
     * Load the images for the given menuItem via Firebase listeners
     * 
     * menuItem - Menu item to load
     * callback - (array) {} callback to fire (once) after images is loaded
     * callbackKey - mixed, pass a unique identifier to add/remove the callback
     */
    loadImage = (menuItem, callback, callbackKey) => {
        const getRef = () => {
            return firebase.database().ref(firebase_path + '/menu_item_images')
            .orderByChild("firebase_index_menu_item_id_image_active")
            .equalTo(`${menuItem.id}_1` )
        }
        if (callback && callbackKey ) {
            if (!this.callbackMap[menuItem.id]) {
                // To group callbacks of the same menu item together
                this.callbackMap[menuItem.id] = {}
            }
            this.callbackMap[menuItem.id][callbackKey] = callback
        }
        
        if (this.loadedMenuItem.indexOf(menuItem.id) === -1) {
            // Mark that this menu item already has firebase listener attached
            this.loadedMenuItem.push(menuItem.id)
            let doneLoadValue = false
            getRef()
            .on('child_added', snapshot => {
                if (!doneLoadValue) {
                    // We wait for 'value' listener to trigger first to initialize the
                    // orders array. Adding item one by one from 'child_added' to initialize
                    // orders array will trigger excessive and unnecessary render()
                    return
                }
                
                let menuItemImage = snapshot.val()
                menuItemImage.key = snapshot.key
                this.menuItemImages.push(Object.assign(new MenuItemImage(), menuItemImage))
                this.triggerCallback(null, menuItem)
            })

            getRef()
            .on('child_changed', snapshot => {       
                let changedImageData = Object.assign(new MenuItemImage(), snapshot.val())
                changedImageData.key = snapshot.key
                
                let menuItemImages = this.menuItemImages
                let index = menuItemImages.findIndex(oldImageData => oldImageData.id == changedImageData.id)
                if (index > -1) {
                    menuItemImages.splice(index, 1, changedImageData)
                }
                this.triggerCallback(null, menuItem)
            })

            // Get the data on a post that has been removed
            getRef().on("child_removed", (snapshot) => {
                var deletedItem = snapshot.val();
                let index = this.menuItemImages.findIndex(menuItemImage => menuItemImage.id == deletedItem.id)
                if (index > -1) {
                    this.menuItemImages.splice(index, 1)
                }
                this.triggerCallback(null, menuItem)
            });

            getRef()
            .once('value', snapshot => {
                snapshot.forEach(childSnapshot => {
                    let menuItemImage = Object.assign(new MenuItemImage(), childSnapshot.val())
                    menuItemImage.key = childSnapshot.key
                    this.menuItemImages.push(menuItemImage)
                })
                doneLoadValue = true
                this.triggerCallback(null, menuItem)
            })
            return
        }
        this.triggerCallback(callbackKey, menuItem)
    }

    triggerCallback = (callbackKey, menuItem) => {
        if (callbackKey) {
            // Has specific callback key, most probably is fist time attaching listener
            if (menuItem && this.callbackMap[menuItem.id] && this.callbackMap[menuItem.id][callbackKey]) {
                let menuItemImages = this.filterMenuItemImages(menuItem)
                this.callbackMap[menuItem.id][callbackKey](menuItemImages)
            }
        }
        else {
            // Notify all listeners of this menuItem
            if (menuItem && this.callbackMap[menuItem.id]) {
                let menuItemImages = this.filterMenuItemImages(menuItem)
                Object.keys(this.callbackMap[menuItem.id]).forEach(callbackKey => {
                    this.callbackMap[menuItem.id][callbackKey] && this.callbackMap[menuItem.id][callbackKey](menuItemImages)
                })
            }
        }
    }
}